__turbopack_context__.v({
  "error": "TextInput-module-scss-module__SHIZKG__error",
  "input": "TextInput-module-scss-module__SHIZKG__input",
  "main": "TextInput-module-scss-module__SHIZKG__main",
  "textarea": "TextInput-module-scss-module__SHIZKG__textarea",
});
